import { styles, padding } from '@/common/style';

export const Styles = {
    box: {
        default: styles({
            justifyContent: 'center',
            alignItems: 'center',
        } as any),
        type: {
            default: styles({
                backgroundColor: 'transparent',
                borderColor: 'rgba(0, 0, 0, 0.12)',
                borderWidth: 1,
            }),
            primary: styles({
                backgroundColor: '#ff4906',
                borderColor: '#ffffff',
                borderWidth: 0,
            }),
            text: styles({
                backgroundColor: 'transparent',
                borderColor: '#ffffff',
                borderWidth: 1,
            }),
            white: styles({
                backgroundColor: '#ffffff',
                borderColor: '#ffffff',
                borderWidth: 0,
            }),
        },
        size: {
            mini: styles({
                height: 24,
                borderRadius: 4,
                ...padding(0, 8),
            }),
            small: styles({
                height: 32,
                borderRadius: 6,
                ...padding(0, 12),
            }),
            middle: styles({
                height: 40,
                borderRadius: 6,
                ...padding(0, 16),
            }),
            large: styles({
                height: 48,
                borderRadius: 6,
                ...padding(0, 24),
            }),
            huge: styles({
                height: 56,
                borderRadius: 6,
                ...padding(0, 32),
            }),
        },
        shape: {
            rect: styles({}),
            round: styles({
                borderRadius: 28,
            }),
        },
        disabled: {
            true: styles({
                opacity: 0.4,
            }),
            false: styles({}),
        },
    },
    text: {
        type: {
            default: styles({
                color: '#000000',
            }),
            primary: styles({
                color: '#ffffff',
            }),
            text: styles({
                color: '#ffffff',
            }),
            white: styles({
                color: '#000000',
            }),
        },
        size: {
            mini: styles({
                fontSize: 12,
            }),
            small: styles({
                fontSize: 14,
            }),
            middle: styles({
                fontSize: 16,
            }),
            large: styles({
                fontSize: 18,
            }),
            huge: styles({
                fontSize: 20,
            }),
        },
    },
};
